import { ENTITY_LABELS } from "../../../utils/labelMapping";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import breakupClasses from "../../../Component/BrandIndexHistory/BrandIndexBreakups.module.css";
import useBaseResponsesModal from "../../../Component/BaseResponseComponent/useBaseResponsesModal";
import BaseResponsesModal from "../../../Component/BaseResponseComponent/BaseResponsesModal";
import { formatSectionLabel } from "../../../utils/helpers";
import { Skeleton, Tab, Tabs, Tooltip, IconButton } from "@mui/material";
import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import AnimatedNumber from "../../../Component/AnimatedNumber/AnimatedNumber";
import BrandAuditIndexBreakups from "../../../Component/BrandIndexHistory/BrandAuditIndexBreakups";
import Rankings from "../../../Component/BrandIndexHistory/Rankings";
import SentimentDriversTable from "../../../Component/BrandIndexHistory/SentimentDrivers";
import SentimentTable from "../../../Component/BrandIndexHistory/SentimentTable";
import AverageSentimentScores from "../../../Component/BrandIndexHistory/AverageSentimentScores";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import Header from "../../../Component/Header/Header";
import Modal from "../../../Component/Modal/Modal";
import Alert from "../../../Component/UI/Alert/Alert";
import { AuthContext } from "../../../context/auth-context";
import { getMetricExplainations } from "../../../utils/constant";
import {
  extractAttribute,
  extractDomain,
  replacePlaceholders,
  transformDriverData,
} from "../../../utils/helpers";
import AttributesOverview from "../CompAttributes/CompAttributes";
import BrandInsights from "../BrandInsights/BrandInsights";
import BrandOverview from "../BrandOverview/BrandOverview";
import CategoryDimensions from "../CategoryDimensions/CategoryDimensions";
import CompetitiveOverview from "../CompetitiveOverview/CompetitiveOverview";
import Conversations from "../Conversations/Conversations";
import ContentMapping from "../ContentMapping/ContentMapping";
import Competitors from "../Competitors/Competitors";
import CoreAttributes from "../CoreAttributes/CoreAttributes";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import FocusAreaOverView from "../FocusArea/focusArea";
import MarketItem from "../MarketComparison/MarketComparisonForItem";
import MarketOverview from "../MarketOverview/MarketOverview";
import PersonaOverview from "../PersonaOverview/PersonaOverview"
import Share from "../Share/Share";
import SourcesOverview, {
  SourceCompareControls,
  SOURCES_CATEGORY_COMPARISON_OPTIONS,
  getSourceDimensionOptions,
} from "../Sources/sourcesOverview";
import Taxonomy from "../Taxonomy/Taxonomy";
import GaugeChart from "./../../../Component/GaugeChart/GaugeChart";
import WeightedDonutChart from "./../../../Component/WeightedDonutChart/WeightedDonutChart";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import LLMIndicator from "./../LLMIndicator/LLMIndicator";
import classes from "./BrandScore.module.css";
// import CompetitorSummary from "../CompetitorSummary/CompetitorSummary";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch } from "react-redux";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import { toast } from "react-toastify";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import { filterKey } from "../BrandAudit";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import {
  formatSourceData,
  formatOldSourceData,
} from "../../../utils/metric-sources";
import {
  calcBrandIndexScore,
  getBrandPillarsAvg,
  getProductDimensionsAvg,
  getPurchaseCriteriaAvg,
  RBI_COLORS,
  RBI_WEIGHTS,
} from "../../../utils/brandIndexCalc";
import DashboardCheckbox from "../SelectedComponent/DashboardCheckbox";
import BrandAvatar from "../../../Component/Avatar/Avatar"
import HTMLReportTab from "../HTMLReportTab/HTMLReportTab";

export let tab = {
  brandOverview: "nev_brandoverview",
  competitiveOverview: "nev_competitiveoverview",
  marketOverview: "nev_marketoverview",
  personaOverview: "nev_personaoverview",
  conversation: "nev_conversation",
  contentMapping: "nav_contentMapping"
};

let IntialabName = {
  nev_brandoverview: `${ENTITY_LABELS.brand} Overview`,
  nev_competitiveoverview: "Competitive Overview",
  nev_marketoverview: "Market Overview",
  nev_personaoverview: "Persona Overview",
  // nev_conversation: "Conversation"
};

// Exportable tabName object (starts with initial state)
export let tabName = { ...IntialabName };

export function resetTabName() {
  tabName = {
    nev_brandoverview: `${ENTITY_LABELS.brand} Overview`,
    nev_competitiveoverview: "Competitive Overview",
    nev_marketoverview: "Market Overview",
    nev_personaoverview: "Persona Overview",
    // nev_conversation: "Conversation"
  };
}

export default function BrandScoreMain({
  categories,
  market,
  llms,
  competitors,
  brand,
  dashbaordActiveTab,
  setDashbaordActiveTab,
  enableHTMLReport = false,
  transactionId,
}) {
  const discoveryCtx = useContext(DiscoveryContext);

  const discoveryType = discoveryCtx.type || "brand";
  const showMarketTab =
    Array.isArray(discoveryCtx?.markets) && discoveryCtx.markets.length > 1;
  const showPersonaTab =
    Array.isArray(discoveryCtx?.persona) && discoveryCtx?.persona?.length > 1;
  const conversationEnabled = discoveryCtx.conversationEnabled;
  // -------------------------------
  // 1. Build overview tab structure dynamically
  // -------------------------------
  const overviewTabs = [
    { key: "brand", component: <BrandOverview /> },
    { key: "competitive", component: <CompetitiveOverview /> },
  ];

  if (showMarketTab) {
    overviewTabs.push({
      key: "market",
      component: <MarketOverview />,
    });
  }

  if (showPersonaTab) {
    overviewTabs.push({
      key: "persona",
      component: <PersonaOverview />,
    });
  }

  // -------------------------------
  // 2. Compute dynamic tab indexes
  // -------------------------------
  const categoryStartIndex = overviewTabs.length;
  const conversationsTabIndex = categoryStartIndex + categories.length;
  const contentMappingTabIndex = conversationsTabIndex + 1;
  const htmlReportTabIndex = conversationEnabled
    ? contentMappingTabIndex + 1
    : conversationsTabIndex;
  const handleTabChange = (event, newValue) => {
    // const difference = Math.abs(newValue - categoryStartIndex);
    // const selectedCategory = discoveryCtx.category[difference];
    // discoveryCtx.updateSelectedCategory(selectedCategory);
    setDashbaordActiveTab(newValue);
    if (
      newValue >= categoryStartIndex &&
      newValue < categoryStartIndex + categories.length
    ) {
      const categoryIndex = newValue - categoryStartIndex;
      const selectedCategory = discoveryCtx.category[categoryIndex];

      discoveryCtx.updateSelectedCategory(selectedCategory);
    }
    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("tabchange"));
    let showReportCheckbox = discoveryCtx?.state?.showReportCheckbox ?? false;
    if (!showReportCheckbox) {
      discoveryCtx.showAnimation();
    }
  };

  tabName["nev_brandoverview"] =
    discoveryType === "brand" ? `${ENTITY_LABELS.brand} Overview` : `${ENTITY_LABELS.product} Overview`;

  if (!categories || !llms) return null;
  if (categories.length === 0 || llms.length === 0) return null;

  return (
    <div>
      <Tabs
        value={dashbaordActiveTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {true && (
          <Tab
            key="brand"
            label={`${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product
              } Overview`}
            id={tab.brandOverview}
          />
        )}

        {true && (
          <Tab
            key="competitive"
            label="Competitive Overview"
            id={tab.competitiveOverview}
          />
        )}

        {showMarketTab && (
          <Tab
            key="market"
            label={"Market Overview"}
            id={tab.marketOverview}
          />
        )}
        {showPersonaTab && (
          <Tab
            key="Persona"
            label={"Persona Overview"}
            id={tab.personaOverview}
          />
        )}
        {categories.map((category, index) => {
          /*allocating dynamic id to category  tab for selection perpose*/
          let categoryKey = category.replace(/\s+/g, "_");
          tab[`${category}`] = `nav_${categoryKey}`;
          tabName[`nav_${categoryKey}`] = category;
          return (
            <Tab key={category} label={category} id={tab[`${category}`]} />
          );
        })}
        {conversationEnabled && (
          <Tab
            key="conversations"
            label="Conversations"
            id={tab.conversation}
          />
        )}
        {conversationEnabled && (
          <Tab
            key="contentMapping"
            label="Content Mapping"
            id={tab.contentMapping}
          />
        )}
        {enableHTMLReport && discoveryType !== "category" && (
          <Tab
            key="htmlReport"
            label="Reporting"
            id="nav_htmlReport"
          />
        )}
      </Tabs>
      {overviewTabs.map((t, i) => dashbaordActiveTab === i && t.component)}

      {categories.map((category, index) => {
        return (
          dashbaordActiveTab === index + categoryStartIndex && (
            <CategoryTab
              key={category}
              category={category}
              index={index}
              market={market}
              llms={llms}
              competitors={competitors}
              brand={brand}
              dashbaordActiveTab={dashbaordActiveTab}
              categoryStartIndex={categoryStartIndex}
            />
          )
        );
      })}
      {conversationEnabled && dashbaordActiveTab === conversationsTabIndex && <Conversations />}
      {conversationEnabled && dashbaordActiveTab === contentMappingTabIndex && <ContentMapping />}
      {enableHTMLReport && discoveryType !== "category" && dashbaordActiveTab === htmlReportTabIndex && (
        <HTMLReportTab
          brandName={discoveryCtx.entity}
          categories={discoveryCtx.category || []}
          llms={discoveryCtx.llm || []}
          markets={discoveryCtx.markets || []}
          personas={
            discoveryCtx?.persona
              ?.map((p) => (typeof p === "string" ? p : p?.title))
              ?.filter(Boolean) || []
          }
          transactionId={transactionId}
        />
      )}
    </div>
  );
}

const BrandIndexScore = React.memo(function BrandIndexScore({
  tab,
  category,
  market,
  llmSections,
}) {
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryType = discoveryCtx.type || "brand";
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const selectedPersona = discoveryCtx?.state?.selectedPersona;
  const id = `indexscore`;
  const title = `${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product
    } Index Score`;
  let uniqueKey = `${tab[category]}_${id}_${selectedMarket ?? ""}_${selectedPersona ?? ""}`;
  const { checked } = useIsSelectedSection({ id, uniqueKey });

  return (
    <MUICard className="p-4">
      <div className="Heading-checkbox">
        <h5>{title}</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id,
                  title,
                  category,
                  market: discoveryCtx?.state?.selectedMarket ?? market,
                  tab: tab[category],
                  uniqueKey,
                  llm: null,
                },
                checked,
                id,
              });
            }}
          />
        )}
      </div>
      <hr />
      <div className={classes.printSpacing} id={id}>
        {llmSections}
      </div>
    </MUICard>
  );
});

function CategoryTab({
  category,
  index,
  market,
  llms,
  competitors,
  brand,
  dashbaordActiveTab,
  categoryStartIndex
}) {
  const [showShareModal, setShowShareModal] = useState(false);
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const isCompanyUser = user?.user_role?.role?.name === "Company user";
  const entity = discoveryCtx.entity;
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const discoveryType = discoveryCtx.type || "brand";
  const transactionStatus = discoveryCtx.state.transactionStatus;
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const selectedPersona = discoveryCtx?.state?.selectedPersona;
  const primaryLLM = discoveryCtx.primary_llm;
  const primaryPersona = discoveryCtx?.persona[0]?.title ?? discoveryCtx?.persona[0];
  const selectedCompetitor = discoveryCtx?.state?.selectedCompetitor;
  let competitorsName = discoveryCtx?.competitors?.[category]?.map((c) => c.name) ?? [];
  competitorsName.unshift(entity);
  let hasError = false;
  let loading = true;
  const selectedInput = {
    llm: selectedLLM,
    market: selectedMarket,
    category,
    brand: discoveryCtx.entity,
    product: null,
  };
  let domain = extractDomain(
    discoveryCtx?.competitors?.["default"]?.[0]?.domain ?? "example.com"
  );

  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "70%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  const data =
    discoveryCtx.brand_scores[selectedLLM][category][selectedMarket][selectedPersona]?.[selectedCompetitor]
      ?.extras;

  if (data?.sentimentMeta && data?.sentiementKeyDrivers) {
    loading = false;
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }

  const {
    infoModalOpen: categoryInfoModalOpen, infoModalTitle: categoryInfoModalTitle,
    infoModalContent: categoryInfoModalContent, closeInfoModal: closeCategoryInfoModal,
    hasSections, productMappingAttribute,
    handleInfoClick, handleAllBaseResponsesClick,
  } = useBaseResponsesModal(data,"visibility");

  const pdfRef = useRef(null);

  const header = (
    <Header
      title={
        <div className={classes.title_container} id="logo">
          {/* {domain && (
            <img
              className={classes.logo}
              src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
            />
          )} */}
          <BrandAvatar
            domainName={domain}
            brandName={entity}
            className={classes.brandAvatar}
          />
          <div className="pt-2">
            <div className={classes.title}>
              <span>{entity}</span>
            </div>
            {category && (
              <div className={classes.label_container}>
                <span className={classes.title_label}>{category}</span>
                {market ? (
                  <>
                    <span>&middot;</span>
                    <span className={classes.title_label}>
                      {market == "GeneralMarket" ? "General Market" : market}
                    </span>
                  </>
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            )}
          </div>
        </div>
      }
      titleClassName={classes.title}
      className={classes.header}
      renderAction={() => {
        return (
          <div className="mx-3">
            <MUIIconButton
              title="Click to Share"
              className="mx-3"
              onClick={() => setShowShareModal(true)}
            >
              <ShareOutlinedIcon color="primary" />
            </MUIIconButton>
          </div>
        );
      }}
    />
  );

  const llmSections = (
    <div>
      <BrandScore
        category={category}
        market={market}
        entity={brand}
        llms={llms}
      />
    </div>
  );

  const competitorsData = (
    <div className={classes.section}>
      {competitors[category]?.length > 0 && (
        <Competitors
          category={category}
          entity={brand}
          llm={selectedLLM}
          market={market}
          isCategoryOverview={true}
        />
      )}
    </div>
  );

  const reachData = data?.productRankingsArray && (
    <MUICard className="p-4 mb-4">
      <div
        style={{ display: "flex", flexDirection: hasSections ? "column" : "row" }}
        id="print-pdf"
        ref={pdfRef}
      >
        {hasSections ? (
          (() => {
            let globalIndex = 0;

            return Object.entries(productMappingAttribute).map(
              ([sectionKey, indices]) => {
                const sectionIndices = indices.map(() => globalIndex++);

                return (
                  <div key={sectionKey} className={breakupClasses.section_block} data-report-section="reach">
                    <div className={breakupClasses.section_header}>
                      <h6 style={{ margin: 0 }}>
                        {formatSectionLabel(sectionKey)}
                      </h6>
                  {!isCompanyUser && (
                    <Tooltip title="View Base Prompt" arrow>
                      <IconButton
                        size="small"
                        onClick={() => handleInfoClick(sectionKey, indices)}
                        sx={{
                          padding: '4px',
                          '&:hover': {
                            backgroundColor: 'primary.light',
                            color: 'primary.main'
                          }
                        }}
                      >
                        <InfoOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                    </div>
                    <div style={{ display: "flex" }}>
                      <Rankings
                        onRankChange={(e) => { }}
                    rankings={indices.map(
                      (i) => data.productRankingsArray[i]
                    )}
                        pIndices={indices}
                        sectionIndices={sectionIndices}
                        rankMatchesIndices={data?.rankMatchesIndices}
                        name={
                          data.favorabilities?.length > 0
                            ? data?.favorabilities[0]?.name
                            : ""
                        }
                      />
                    </div>
                  </div>
                );
              }
            );
          })()
        ) : (
          <div
            data-report-section="reach"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row"
            }}
          >
            <Rankings
              onRankChange={(e) => { }}
              rankings={data?.productRankingsArray}
              rankMatchesIndices={data?.rankMatchesIndices}
              name={
                data.favorabilities?.length > 0
                  ? data?.favorabilities[0]?.name
                  : ""
              }
            />
          </div>
        )}
        <hr />
      </div>
    </MUICard>
  );

  const sentimentData = (
    <>
      {data?.sentimentMeta && !loading && !hasError && (
        <SentimentTable
          data={data}
          showScore={false}
          selectedInput={selectedInput}
          showInfoIcon={!isCompanyUser}
        />
      )}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={"Error Fetching Sentiment Data"}
            message={"Request Failed"}
          />
        </div>
      )}
      {loading && !hasError && <LoadingSkeletion />}
    </>
  );

  const averageSentimentScores = (
    <>
      {data?.sentimentMeta && !loading && !hasError && (

        <AverageSentimentScores
          category={category}
          market={selectedMarket}
          selectedPersona={selectedPersona}
          selectedLLM={selectedLLM}
          competitors={competitors}
        />

      )}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={"Error Fetching Sentiment Data"}
            message={"Request Failed"}
          />
        </div>
      )}
      {loading && !hasError && <LoadingSkeletion />}
    </>
  );

  const sentimentDrivers = (
    <>
      {data?.sentiementKeyDrivers &&
        !loading &&
        !hasError &&
        Object.keys(data?.sentiementKeyDrivers).length > 0 && (
          <>
            {/* <hr />
                     <h5>3. Sentiment Drivers</h5> */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.5rem",
              }}
            >
              {data?.sentiementKeyDrivers?.positive &&
                data?.sentiementKeyDrivers?.positive.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data?.sentiementKeyDrivers?.positive,
                        "Positive"
                      )}
                      title={discoveryCtx?.mapMetricTitle?.("Positive Sentiment Drivers") ?? "Positive Sentiment Drivers"}
                      driverType="positive"
                      sentimentData={data}
                      showInfoIcon={!isCompanyUser}
                    />
                  </div>
                )}

              {data?.sentiementKeyDrivers?.negative &&
                data?.sentiementKeyDrivers?.negative.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data?.sentiementKeyDrivers?.negative,
                        "Negative"
                      )}
                      title={discoveryCtx?.mapMetricTitle?.("Negative Sentiment Drivers") ?? "Negative Sentiment Drivers"}
                      driverType="negative"
                      sentimentData={data}
                      showInfoIcon={!isCompanyUser}
                    />
                  </div>
                )}
            </div>
          </>
        )}
      {hasError && (
        <div className={classes.error}>
          <ErrorView
            title={"Error Fetching Sentiment Driver"}
            message={"Request Failed"}
          />
        </div>
      )}
      {loading && !hasError && <LoadingSkeletion />}
    </>
  );

  const positiveNegativeAttributes = (
    <div id={`${category}_positivenegative_attributes`}>
      {competitors[category]?.length > 0 && (
        <AttributesOverview category={category} isCategoryOverview={true} />
      )}
    </div>
  );

  const coreAttributes = (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10 }}
    >
      <div className={classes.flex_one}>
        {competitors[category]?.length > 0 && (
          <CoreAttributes category={category} entity={entity} />
        )}
      </div>
    </div>
  );

  const taxonomy = (
    <div className={classes.section_summary}>
      <div className={classes.flex_one}>
        {competitors[category]?.length > 0 && (
          <Taxonomy category={category}/>
        )}
      </div>
    </div>
  );

  const taxonomyAndCoreAttributes = () => {
    if (discoveryCtx.type === "brand") {
      return coreAttributes;
    } else {
      return taxonomy;
    }
  };

  const categoryDimensions = (
    <div
      className={classes.section_summary}
      style={{ paddingTop: 10, paddingBottom: 10 }}
    >
      <div className={classes.flex_one}>
        {competitors[category] && competitors[category]?.length > 0 && (
          <CategoryDimensions category={category} entity={entity} />
        )}
      </div>
    </div>
  );

  const realtimeActions = (
    <div className={classes.section}>
      {competitors[category] && competitors[category]?.length > 0 && (
        <FocusAreaOverView category={category} isCategoryOverview={true} />
      )}
    </div>
  );

  const [sourcesFilter, setSourcesFilter] = useState({ value: "LLM", label: "Compare by LLM" });
  const [sourcesComparisons, setSourcesComparisons] = useState(discoveryCtx.llm || []);

  useEffect(() => {
    if (sourcesFilter.value === "LLM") {
      setSourcesComparisons(discoveryCtx.llm || []);
    }
  }, [discoveryCtx.llm]);

  const sourcesHandleFilterChange = (newFilter) => {
    setSourcesFilter(newFilter);
    setSourcesComparisons(
      getSourceDimensionOptions(newFilter.value, discoveryCtx).map((o) => o.value)
    );
  };

  const sourcesDimensionOptions = getSourceDimensionOptions(sourcesFilter.value, discoveryCtx);

  const sourcesControlsJSX = (
    <SourceCompareControls
      sourceFilter={sourcesFilter}
      selectedComparisons={sourcesComparisons}
      comparisonOptions={SOURCES_CATEGORY_COMPARISON_OPTIONS}
      dimensionOptions={sourcesDimensionOptions}
      onFilterChange={sourcesHandleFilterChange}
      onComparisonsChange={setSourcesComparisons}
    />
  );

  const sources = (
    <SourcesOverview
      category={category}
      isCategoryOverview={true}
      externalFilter={sourcesFilter}
      externalComparisons={sourcesComparisons}
      onExternalFilterChange={sourcesHandleFilterChange}
      onExternalComparisonsChange={setSourcesComparisons}
    />
  );

  let id = `BrandInsights`;
  let title = `${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product} Insights`;
  let uniqueKey = `${tab[category]}_${id}_${discoveryCtx.state.selectedLLM}`;
  const { checked } = useIsSelectedSection({ id, uniqueKey });

  const DetailSection = useMemo(() => {
    return (
      <>
        <div>
          <MUICard className="p-4 pb-2 mb-4">
            {discoveryCtx.state.showReportCheckbox && (
              <DashboardCheckbox
                dashboardTab={tab[category]}
                dashboardName={category}
                category={category}
              />
            )}
            <div className="Heading-checkbox">
              <h5>{title}</h5>

              {discoveryCtx.state.showReportCheckbox && (
                <Checkbox
                  checked={checked}
                  onChange={() => {
                    discoveryCtx?.clickComponentCheckbox({
                      uniqueKey,
                      filter: {
                        id: id,
                        title: title,
                        category: category,
                        market: null,
                        tab: tab[category],
                        uniqueKey,
                      },
                      checked,
                      id,
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}
            </div>
            <hr />
            <div id={id}>
              {header}
              <div className={classes.printSpacing}>
                <BrandInsights
                  entity={entity}
                  category={category}
                  llm={primaryLLM}
                />
              </div>

            </div>
          </MUICard>
        </div>
      </>
    );
  }, [
    id,
    title,
    uniqueKey,
    category,
    market,
    entity,
    selectedLLM,
    discoveryType,
    discoveryCtx.state.selectedLLM,
    discoveryCtx.state.showReportCheckbox,
    header,
    llmSections,
    checked,
  ]);

  const VisibilityData = () => {
    let id = `Reach_data`;
    const [showModal, setShowModal] = useState(false);
    const selectedLLM = discoveryCtx?.state?.selectedLLM;
    const selectedMarket = discoveryCtx?.state?.selectedMarket;
    const selectedPersona = discoveryCtx?.state?.selectedPersona;
    const isPropensity = discoveryCtx?.state?.rbiType === "propensityToBuy";

    let title = discoveryCtx?.mapMetricTitle?.(`${ENTITY_LABELS.rank} Data`) ?? `${ENTITY_LABELS.rank} Data`;
    let location = null;
    /*visibility Prompt change according to category so that why we  need to extract prompt for metricSettingObject by passing category */
    let visibilityPrompt = extractAttribute({
      category: category,
      type: isPropensity ? "propensity-visibility" : "visibility",
      metricSettingObject: discoveryCtx?.state?.metricSettingObject ?? {},
    })?.[0]
    // discoveryCtx?.state?.metricSettingObject?.visibility?.[0]?.attribute ??
    // "{{ persona_phrase }} Provide a ranked list of top {{ count }} {{ category }} {{ type }} {{ combined_phrase }}. Return a ranking set based on your best judgment, dont ask for any critieria or basis for ranking.";

    if (visibilityPrompt && (typeof visibilityPrompt === "string")) {
      let persona = selectedPersona
      let market = discoveryCtx.state.selectedMarket;
      const isGeneralPersona =
        !persona ||
        persona === "General Profile" ||
        persona === "General Persona";
      const isGeneralMarket = market === "General Market";

      if (isGeneralPersona) {
        visibilityPrompt = visibilityPrompt.replace(
          /^\s*I am a\s*\{\{\s*persona\s*\}\}\s*,?\s*/i,
          ""
        );
        visibilityPrompt = visibilityPrompt.replace(/\s+for me\b/gi, "");
      }

      if (isGeneralMarket) {
        visibilityPrompt = visibilityPrompt.replace(
          /\s*that are available in\s*\{\{\s*market\s*\}\}\s*/i,
          " "
        );
      }

      const variables = {
        persona,
        category,
        count: 10,
        market,
        type: discoveryCtx.type === "product" ? "products" : "companies",
      };

      visibilityPrompt = replacePlaceholders(visibilityPrompt, variables)
        .replace(/\s{2,}/g, " ")
        .trim();
    }

    let uniqueKey = `${tab[category]}_${id}_${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}_${selectedCompetitor ?? 0}`;
    const { checked } = useIsSelectedSection({ id, uniqueKey });

    return (
      <>
        <div>
          <MUICard className="p-4 ">
            <div className="Heading-checkbox">
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <h5 style={{ margin: 0 }}>{title}</h5>
                {/* {data?.baseResponses?.length > 0 && (
                  <InfoOutlinedIcon
                    className={breakupClasses.info_icon}
                    onClick={handleAllBaseResponsesClick}
                  />
                )} */}
              </div>

              {discoveryCtx.state.showReportCheckbox && (
                <Checkbox
                  checked={checked}
                  onChange={() => {
                    discoveryCtx?.clickComponentCheckbox({
                      uniqueKey,
                      filter: {
                        id: id,
                        title: title,
                        category: category,
                        market: discoveryCtx?.state?.selectedMarket,
                        tab: tab[category],
                        competitorName: competitorsName?.[selectedCompetitor],
                        competitor: selectedCompetitor,
                        uniqueKey,
                      },
                      checked,
                      id,
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}
              {/* <MUIIconButton
                data-html2canvas-ignore
                onClick={() => {
                  setShowModal(true);
                }}
                className={classes.settings}
              >
                <InfoOutlinedIcon />
              </MUIIconButton> */}
              <div className={classes.dropdownWrapper} style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                <MUISelect
                  fullWidth={false}
                  optionValue={selectedCompetitor}
                  label={"Competitor"}
                  id={filterKey.competitor}
                  options={(competitorsName || []).map((competitor, index) => {
                    return {
                      name: competitor,
                      value: index,
                    };
                  })}
                  onChange={(e) => {
                    discoveryCtx.updateSelectedCompetitor(e.target.value);
                  }}
                />
              </div>
            </div>
            <hr />

            <div className={classes.printSpacing} id={id}>
              {reachData}
            </div>
          </MUICard>
          <Modal
            width={500}
            open={showModal}
            handleClose={() => setShowModal(false)}
            title={discoveryCtx?.mapMetricTitle?.(`${ENTITY_LABELS.rank} Prompt`) ?? `${ENTITY_LABELS.rank} Prompt`}
          >
            <div>{visibilityPrompt}</div>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <div
      key={entity + category + "section"}
      style={{
        display:
          dashbaordActiveTab === index + categoryStartIndex ? "block" : "none",
      }}
    >
      {DetailSection}
      <BrandIndexScore
        tab={tab}
        category={category}
        market={market}
        llmSections={llmSections}
      />

      <div className={classes.pageBreak} />

      <div className={classes.printSpacing}>{competitorsData}</div>

      <VisibilityData />

      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="sentiment_data"
        title={discoveryCtx?.mapMetricTitle?.("Sentiment Data") ?? "Sentiment Data"}
        componentOutput={sentimentData}
        category={category}
        market={market}
        persona={primaryPersona}
        uniqueKeyPass={`${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}_${selectedCompetitor ?? 0}`}
        isCompetitiveSelection={true}
      />
      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="average_sentiment_scores"
        title={discoveryCtx?.mapMetricTitle?.("Average Sentiment Scores") ?? "Average Sentiment Scores"}
        componentOutput={averageSentimentScores}
        category={category}
        market={market}
        persona={primaryPersona}
        uniqueKeyPass={`${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}_${selectedCompetitor ?? 0}`}
        isCompetitiveSelection={true}
      />
      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="sentiment_driver"
        title={discoveryCtx?.mapMetricTitle?.("Sentiment Driver") ?? "Sentiment Driver"}
        componentOutput={sentimentDrivers}
        category={category}
        market={market}
        persona={primaryPersona}
        uniqueKeyPass={`${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}_${selectedCompetitor ?? 0}`}
        isCompetitiveSelection={true}
      />
      {/* <div className={classes.container}> */}
      <ComponentWithCheckbox
        id={`positiveNegativeAttributes`}
        title="Positive and Negative Attributes"
        titleAction={<AttributesInfoIconOnly category={category} />}
        componentOutput={positiveNegativeAttributes}
        category={category}
        market={selectedMarket}
        persona={selectedPersona}
      />
      {/* </div> */}
      <div className={classes.pageBreak} />
      <div className={classes.printSpacing}>
        <ComponentWithCheckbox
          id={
            discoveryCtx.type === "brand" ? "Brand_Piller" : "Product_Dimension"
          }
          title={
            discoveryCtx.type === "brand"
              ? ENTITY_LABELS.brandPillar
              : ENTITY_LABELS.productDimension
          }
          componentOutput={taxonomyAndCoreAttributes()}
          category={category}
          market={selectedMarket}
          persona={selectedPersona}
        />
      </div>

      <ComponentWithCheckbox
        id="purchase_criteria"
        title={ENTITY_LABELS.purchaseCriteria}
        componentOutput={categoryDimensions}
        category={category}
        market={selectedMarket}
        persona={selectedPersona}
      />
      <div className={classes.pageBreak} />
      <div className={classes.container}>
        {/* <div className={classes.printSpacing}> */}
        <div style={{ width: "100%" }}>
          <ComponentWithCheckbox
            id="sources"
            title="Sources"
            componentOutput={sources}
            category={category}
            market={market}
            persona={primaryPersona}
            uniqueKeyPass={`${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}`}
            rightAction={sourcesControlsJSX}
          />
        </div>
        {/* </div> */}
      </div>
      <div className={classes.pageBreak} />
      <ComponentWithCheckbox
        id="realtimeActions"
        title="Focus Area"
        componentOutput={realtimeActions}
        category={category}
        market={market}
        persona={primaryPersona}
        uniqueKeyPass={`${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}`}
      />

      <BaseResponsesModal
        open={categoryInfoModalOpen}
        title={categoryInfoModalTitle}
        content={categoryInfoModalContent}
        onClose={closeCategoryInfoModal}
      />
      <Modal
        height="85vh"
        width="700"
        title="Share Link"
        open={showShareModal}
        handleClose={() => setShowShareModal(false)}
      >
        <Share setShowShareModal={setShowShareModal} />
      </Modal>
    </div>
  );
}

function AttributesInfoIconOnly({ category }) {
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const discoveryType = discoveryCtx.type || "brand";
  const selectedLLM = discoveryCtx.state.selectedLLM;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const primaryMarket = discoveryCtx.markets[0];
  const attributeRef = discoveryCtx.positive_negative_attributes
    ?.[selectedLLM]?.[category]?.[primaryMarket]?.[selectedPersona];
  const iswebSearchLLM = selectedLLM?.toLowerCase()?.includes("search");
  const isCompanyUser = user?.user_role?.role?.name === "Company user";

  const { handleSignalStrengthClick, infoModalOpen, infoModalTitle, infoModalContent, closeInfoModal } =
    useBaseResponsesModal({}, "signal-strength");

  const allBaseResponsesData = Array.isArray(attributeRef)
    ? attributeRef
      .filter(c => c?.baseResponses && Object.keys(c.baseResponses).length > 0)
      .map(c => ({ brandName: c.name, baseResponses: c.baseResponses }))
    : [];

  if (isCompanyUser || allBaseResponsesData.length === 0) return null;

  return (
    <>
      <Tooltip title="View Base Prompt" arrow placement="top">
        <IconButton
          size="small"
          onClick={() => handleSignalStrengthClick(iswebSearchLLM, allBaseResponsesData,discoveryType)}
          sx={{
            padding: "2px",
            color: "rgba(0, 0, 0, 0.54)",
            "&:hover": {
              backgroundColor: "rgba(33, 150, 243, 0.08)",
              color: "#2196F3",
            },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: "18px" }} />
        </IconButton>
      </Tooltip>
      <BaseResponsesModal
        open={infoModalOpen}
        title={infoModalTitle}
        content={infoModalContent}
        onClose={closeInfoModal}
      />
    </>
  );
}

let ComponentWithCheckbox = React.memo(function ({
  id,
  title,
  componentOutput,
  category,
  market,
  uniqueKeyPass,
  persona,
  isCompetitiveSelection = false,
  titleAction = null,
  rightAction = null,
}) {
  id = `${id}`;
  const discoveryCtx = useContext(DiscoveryContext);
  const primaryMarket = discoveryCtx.market;
  const primaryPersona = discoveryCtx.persona[0]?.title ?? discoveryCtx?.persona[0];
  const selectedMarket = discoveryCtx?.state?.selectedMarket;
  const entity = discoveryCtx?.state?.entity;
  const selectedCompetitor = discoveryCtx?.state?.selectedCompetitor;
  let competitorsName = discoveryCtx?.competitors?.[category]?.map((c) => c.name) ?? [];
  competitorsName.unshift(entity);
  /*Brand piller, Applicant Criteria, PN attribute are llm and primary smarket specific and Focus area is llm and market */
  let uniqueKey = uniqueKeyPass
    ? `${tab[category]}_${id}_${uniqueKeyPass}`
    : `${tab[category]}_${id}_${discoveryCtx.state.selectedLLM}_${persona}`;

  const { checked } = useIsSelectedSection({ id, uniqueKey });

  if (primaryMarket !== market) return;
  return (
    <MUICard className="mb-4">
      <div className="Heading-checkbox">
        {/*  Title + inline action (Info icon) */}
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <h5 style={{ margin: 0 }}>{title}</h5>
          {titleAction}
        </div>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: title,
                  category: category,
                  market: selectedMarket,
                  tab: tab[category],
                  ...(isCompetitiveSelection && {
                    competitorName: competitorsName?.[selectedCompetitor],
                    competitor: selectedCompetitor,
                  }),
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
        {rightAction && (
          <div style={{ marginLeft: "auto" }}>{rightAction}</div>
        )}
      </div>
      <hr />
      <div id={id}>{componentOutput}</div>
    </MUICard>
  );
});

function BrandScore({ category, market, llms }) {
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();
  const metricExplainations = getMetricExplainations();
  const discoveryCtx = useContext(DiscoveryContext);
  const customerId = user?.customer_id;
  const entity = discoveryCtx.entity;
  const primaryLLM = discoveryCtx.primary_llm;
  const otherLLMs = llms.filter((l) => l !== primaryLLM);
  const chartref = useRef();
  const brandScoreCtx = discoveryCtx.brand_scores;
  const rankScoreCtx = discoveryCtx.rank_scores;
  const discoveryType = discoveryCtx.type || "brand";
  const searchParams = new URLSearchParams(window.location.search);
  const isReporting = searchParams.get("isReporting") === "true";
  const transactionStatus = discoveryCtx.state.transactionStatus;
  const selectedMarket = discoveryCtx.state.selectedMarket;
  const selectedPersona = discoveryCtx?.state?.selectedPersona;
  const persona = discoveryCtx.persona;
  const showOldSourcesRecord =
    discoveryCtx.state.sourceValidationStatus === "PENDING";
  const selectedInput = {
    llm: primaryLLM,
    market: selectedMarket,
    category,
    brand: discoveryCtx.entity,
    product: null,
  };

  const brandScoreLength =
    brandScoreCtx[primaryLLM][category][selectedMarket][selectedPersona]?.[0]?.total;

  const saveActions = async (
    actionStatement,
    explanation,
    sources,
    brand,
    llm
  ) => {
    setIsActionLoading(true);
    const modifiedObj = {
      title: actionStatement,
      brand,
      persona: "General Persona",
      geography:
        selectedMarket == "General Market"
          ? "General Location"
          : selectedMarket,
      market: "General Market",
      category,
      llm,
      isProduct: discoveryType === "product" ? true : false,
      sources,
    };

    const payload = {
      action_json: [modifiedObj],
      is_archived: 0,
      is_active: 1,
    };
    dispatch(createActionMetric(customerId, payload))
      .then(() => {
        dispatch(fetchActionMetrics(customerId));
        setIsActionLoading(false);
        toast.success("Action Added!", {
          autoClose: 700,
        });
      })
      .catch(() => {
        setIsActionLoading(false);
        toast.error("Something went wrong!", {
          autoClose: 700,
        });
      });
  };

  const getTooltipProps = (index, metric, sources, score, explanation, llm) => {
    const brandIndexSources = showOldSourcesRecord
      ? formatOldSourceData(Object.keys(sources), llm)
      : formatSourceData(sources, llm);
    return {
      metric: metric,
      attribute: "",
      metricScore: Number(score).toFixed(0),
      selectedInput: {
        ...selectedInput,
        llm,
      },
      sources: brandIndexSources,
      addToActionHandler: saveActions,
      actionText: "Add To Action",
      title: explanation,
      isActionLoading: isActionLoading,
      isBrandAudit: true,
      arrow: true,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -18],
              },
            },
          ],
        },
      },
    };
  };

  useEffect(() => {
    if (brandScoreLength > 0) {
      if (chartref.current) {
        setTimeout(() => chartref.current.resize(), 500);
      }
      return;
    }
    llms.map((llm) => {
      // getBrandIndex(llm);
    });
  }, [entity, brandScoreLength]);

  const personaOptions = useMemo(() => {
    return (discoveryCtx?.persona || [])
      .map(p => {
        // New record format
        if (typeof p === "object" && p?.title) {
          return {
            name: p.title,
            value: p.title,
          };
        }

        // Old record format
        if (typeof p === "string") {
          return {
            name: p,
            value: p,
          };
        }

        return null;
      })
      .filter(Boolean);
  }, [discoveryCtx?.persona]);


  let brandScore = brandScoreCtx[primaryLLM][category][selectedMarket][selectedPersona][0];
  let rankScore = rankScoreCtx[primaryLLM][category][selectedMarket][selectedPersona];
  const {
    infoModalOpen, infoModalTitle, infoModalContent,
    closeInfoModal,
  } = useBaseResponsesModal(brandScore?.extras);
  let loading = true;
  let domain = "";
  let reachSources = [];
  let sentimentSources = [];
  let hasError = false;
  let variants = [];
  let isReachValidated = false;
  let isSentimentValidated = false;
  let animation = discoveryCtx?.state?.showAnimation ?? false;

  if (brandScore && brandScore.extras && brandScore.total) {
    domain =
      discoveryCtx?.competitors?.[category] &&
      extractDomain(discoveryCtx?.competitors?.[category]?.[0]?.domain);
    variants =
      discoveryCtx?.competitors?.[category]?.[0]?.variants?.filter(
        (v) => v.active
      ) || [];
    loading = false;
  } else if (transactionStatus === "RETRY") {
    hasError = true;
    loading = false;
  } else if (transactionStatus === "RUNNING") {
    hasError = false;
    loading = true;
  }
  if (brandScore && brandScore.error) {
    loading = false;
    hasError = true;
  }
  let brandScoreAdjustments = { changed: false };
  if (brandScore?.extras?.rank) {
    const [{ name }] = brandScore?.extras?.rank;
    if (
      name.toString().toLowerCase().trim().replaceAll(" ", "") !==
      discoveryCtx.entity.toString().toLowerCase().trim().replaceAll(" ", "")
    ) {
      brandScoreAdjustments.entities = [name, discoveryCtx.entity];
      brandScoreAdjustments.changed = true;
    }
  }
  if (rankScore && rankScore?.sources?.rank) {
    reachSources = rankScore?.sources?.rank;
    isReachValidated = showOldSourcesRecord || rankScore?.isValidated;
  }
  if (brandScore && Array.isArray(brandScore?.extras?.sentimentSources)) {
    sentimentSources = brandScore?.extras?.sentimentSources;
    isSentimentValidated =
      showOldSourcesRecord || brandScore?.extras?.isValidated;
  }

  const showTooltip = primaryLLM?.toLowerCase().includes("search");

  const renderAnimatedNumber = (value) => (
    <AnimatedNumber
      className={classes.score_value}
      start={isReporting || !animation ? value || 0 : 0}
      end={value || 0}
      duration={isReporting || !animation ? 0 : 1500}
    />
  );

  return (
    <div className={classes.wrapper}>
      <MUICard variant="elevated" elevation={0} className={classes.card}>
        <div className={classes.container}>
          <div className={classes.brand_container}>
            <div className={classes.brand_index_wrapper}>
              <div className={classes.brand_index}>
                <div className={classes.main} style={{ display: "block", position: "relative" }}>
                  {!loading && brandScore?.extras && !hasError && (
                    <MUIIconButton
                      data-html2canvas-ignore
                      className={classes.info}
                      onClick={() => setShowBrandIndexBreakups(true)}
                    >
                      <InfoOutlinedIcon />
                    </MUIIconButton>
                  )}
                  <div>
                    <span className={classes.brand_label}>
                      <span className={classes.llm_brand}>
                        {discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product} Index
                        Score
                      </span>
                      <LLMIndicator llm={primaryLLM || "gpt-5.6"} />
                    </span>
                    {loading && !hasError && (
                      <Skeleton width={400} height={350} />
                    )}
                    {!loading && brandScore?.total && !hasError && (() => {
                      const isProduct = discoveryType === "product";
                      const coreAttributesData = discoveryCtx.core_attributes?.[primaryLLM]?.[category]?.[selectedMarket]?.[selectedPersona];
                      const categoryDimensionsData = discoveryCtx.category_dimensions?.[primaryLLM]?.[category]?.[selectedMarket]?.[selectedPersona];
                      const taxonomiesData = discoveryCtx.taxonomies?.[primaryLLM]?.[category]?.[selectedMarket]?.[selectedPersona];
                      const brandPillarsAvg = isProduct
                        ? getProductDimensionsAvg(entity, taxonomiesData)
                        : getBrandPillarsAvg(entity, coreAttributesData);
                      const purchaseCriteriaAvg = getPurchaseCriteriaAvg(entity, categoryDimensionsData);
                      const { total: rbiTotal, visNorm, sentNorm, pillarsNorm, purchaseNorm, contributions } =
                        calcBrandIndexScore({ rank: brandScore?.rank, favorability: brandScore?.favorability, brandPillarsAvg, purchaseCriteriaAvg });
                      const SCORE_CARDS = [
                        { key: "visibility",       label: ENTITY_LABELS.rank,                                  weight: RBI_WEIGHTS.visibility,       raw: brandScore?.rank,        max: 50 },
                        { key: "sentiment",        label: "Sentiment",                                         weight: RBI_WEIGHTS.sentiment,        raw: brandScore?.favorability, max: 50 },
                        { key: "brandPillars",     label: isProduct ? ENTITY_LABELS.productDimension : ENTITY_LABELS.brandPillar, weight: RBI_WEIGHTS.brandPillars, raw: brandPillarsAvg, max: 10 },
                        { key: "purchaseCriteria", label: ENTITY_LABELS.purchaseCriteria,                       weight: RBI_WEIGHTS.purchaseCriteria, raw: purchaseCriteriaAvg,      max: 10 },
                      ];
                      return (
                        <div style={{ display: "flex", alignItems: "center", gap: 20, paddingRight: 40 }}>
                          <div style={{ flex: "0 0 44%", minWidth: 0 }}>
                            <WeightedDonutChart
                              total={rbiTotal}
                              visNorm={visNorm}
                              sentNorm={sentNorm}
                              pillarsNorm={pillarsNorm}
                              purchaseNorm={purchaseNorm}
                              size="large"
                              showLegend={false}
                            />
                          </div>
                          <div style={{ flex: "0 0 calc(56% - 20px)", minWidth: 0, display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", gap: 12 }}>
                            {SCORE_CARDS.map((c) => {
                              const color = RBI_COLORS[c.key];
                              const weightPct = Math.round(c.weight * 100);
                              const rawDisplay = c.raw != null ? (c.max === 10 ? Number(c.raw).toFixed(1) : c.raw) : "—";
                              return (
                                <div key={c.key} style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: `1.5px solid ${color}33`, minWidth: 0 }}>
                                  <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                                    <span style={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: color, flexShrink: 0, display: "inline-block", marginRight: 6 }} />
                                    <Tooltip title={c.label} arrow>
                                      <span style={{ fontSize: 12, fontWeight: 600, color: "#2d3748", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.label}</span>
                                    </Tooltip>
                                    <span style={{ fontSize: 11, color: "#8a94a6", fontWeight: 500, flexShrink: 0, marginLeft: 4 }}>{weightPct}%</span>
                                  </div>
                                  <div style={{ lineHeight: 1 }}>
                                    <span style={{ fontSize: 26, fontWeight: 700, color }}>{rawDisplay}</span>
                                    <span style={{ fontSize: 12, fontWeight: 400, color: "#8a94a6" }}>/{c.max}</span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                  {hasError && (
                    <div className={classes.error_view}>
                      <ErrorView
                        title={`Error Fetching ${discoveryType === "brand" ? ENTITY_LABELS.brand : ENTITY_LABELS.product
                          } index score`}
                        message={"Request Failed"}
                      />
                    </div>
                  )}
                </div>
                {brandScoreAdjustments.changed && (
                  <Alert
                    title={`${ENTITY_LABELS.rank} Score Adjustment`}
                    message={
                      <span>
                        The {ENTITY_LABELS.rank} score has been calculated using the{" "}
                        {discoveryCtx.type}{" "}
                        <b>{brandScoreAdjustments.entities[0]}</b> rather than{" "}
                        <b>{brandScoreAdjustments.entities[1]}</b>
                      </span>
                    }
                  />
                )}
              </div>

              <div className={classes.summary}>
                <div className={classes.dropdownWrapper}>
                  <MUISelect
                    fullWidth={false}
                    optionValue={discoveryCtx.state.selectedPersona}
                    label={"Persona"}
                    id={filterKey.persona}
                    options={personaOptions}
                    onChange={(e) => {
                      discoveryCtx.updateSelectedPersona(e.target.value);
                    }}
                  />
                  <MUISelect
                    fullWidth={false}
                    optionValue={discoveryCtx.state.selectedMarket}
                    label={"Market"}
                    id={filterKey.market}
                    options={(discoveryCtx?.markets || []).map((market) => {
                      return {
                        name: market,
                        value: market,
                      };
                    })}
                    onChange={(e) => {
                      discoveryCtx.updateSelectedMarket(e.target.value);
                    }}
                  />
                </div>
                <div className={classes.llm_card_grid} id="other_llm">
                  {otherLLMs.map((llm, index) => {
                    const brandScore =
                      discoveryCtx.brand_scores[llm][category][
                      selectedMarket
                      ][selectedPersona]?.[0];
                    const rankScore =
                      discoveryCtx.rank_scores[llm][category][selectedMarket][selectedPersona];
                    let reachSourcesData = [];
                    let sentimentSourcesData = [];
                    let isReachSourceValidated = false;
                    let isSentimentSourceValidated = false;
                    if (rankScore && rankScore?.sources?.rank) {
                      reachSourcesData = rankScore?.sources?.rank;
                      isReachSourceValidated =
                        showOldSourcesRecord || rankScore?.isValidated;
                    }
                    if (
                      brandScore &&
                      Array.isArray(brandScore?.extras?.sentimentSources)
                    ) {
                      sentimentSourcesData =
                        brandScore?.extras?.sentimentSources;
                      isSentimentSourceValidated =
                        showOldSourcesRecord || brandScore?.isValidated;
                    }
                    return (
                      <MarketItem
                        brandIndex={brandScore}
                        llm={llm}
                        category={category}
                        market={selectedMarket}
                        persona={selectedPersona}
                        title={llm}
                        getTooltipProps={getTooltipProps}
                        sentimentSources={sentimentSourcesData}
                        reachSources={reachSourcesData}
                        isReachSourceValidated={isReachSourceValidated}
                        isSentimentSourceValidated={isSentimentSourceValidated}
                        selectedInput={{
                          ...selectedInput,
                          llm,
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </MUICard>
      <Modal
        width={1200}
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
      >
        <BrandAuditIndexBreakups
          data={brandScore?.extras}
          isOpen={showBrandIndexBreakups}
          type={discoveryCtx.type}
          llm={primaryLLM}
          category={category}
          market={selectedMarket}
          selectedInput={selectedInput}
          persona={selectedPersona}
          fromBrandAudit={true}
          compIndexScoreMetaData={brandScoreCtx[primaryLLM][category][selectedMarket][selectedPersona]}
          brandProduct={entity}
        />
      </Modal>
      <BaseResponsesModal
        open={infoModalOpen}
        title={infoModalTitle}
        content={infoModalContent}
        onClose={closeInfoModal}
      />
    </div>
  );
}
